import { MediaLibraryFileModel } from '../../../../models/sales-funnel';
import { SystemUserBase } from '../../../../models/system.base.models';

export type ContactItemType =
  | 'instructor'
  | 'customer'
  | 'student'
  | 'lead'
  | 'owner';

export class ContactItem extends SystemUserBase {
  type: ContactItemType;
  avatar?: Partial<MediaLibraryFileModel>[];
  avatar_id?: number[];
  // SystemUserBase has id and email, but re-declaring for clarity or if overrides needed
  // id: number;
  // email: string;

  // Added based on usage in UI and Backend DTO
  title?: string;
  bio?: string;
  phone?: string;
}

export class InstructorItem extends ContactItem {}

export interface ContactStatsDto {
  totalRevenue: number;
  salesCount: number;
  lastSaleDate: number;
  sales: any[];
}

export interface ContactCourse {
  id: number;
  name: string;
  product_id: number;
  progress: number;
  image?: MediaLibraryFileModel[];
  report?: any[];
}

export interface ContactDetailsResult {
  contact: ContactItem;
  stats: ContactStatsDto;
  extraData: ContactCourse[] | any;
}
